module.exports = __webpack_public_path__ + "stockLibrary/service_6-53af287f92f375cec59af4a7fc2cb7e3.png";